import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';
import sprintf from 'sprintf';
import SMConst from 'lib/SMConst';
import moment from 'moment';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReputationListView extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {

    const reputated = this.props.reputated;

    let rows = [];
    this.props.reputations.forEach((reputation)=>{
      const reservation = reputation.reputatable;
      const date = reservation.stay_checkin_at ? reservation.stay_checkin_at : reservation.started_at;
      const start = sprintf(I18n.t("service.label_000002"),
        moment(date).utc().format(I18n.t("datetime.label_000002")));

      let metaRows = [];
      metaRows.push(<li key="0">{start}</li>);
      if (reservation) {
        if (reservation.rent_type == SMConst.RentType.Stay) {
          metaRows.push(
            <li key="1">{I18n.t("service.label_000003")}：<a href={Routes.search_index_path({"event_type":'stay'})}>{I18n.t("service.event_type.stay")}</a></li>
          );
        }
        else {
          metaRows.push(
            <li key="1">{I18n.t("service.label_000003")}：<a href={`/event_types/${reservation.event_type}`}>{reservation.event_type_text}</a></li>
          );
        }
        if (reputated != 'Room') {
          if (reputated == 'Owner') {
            metaRows.push(
              <li key="2">会場：<a href={Routes.space_path(reservation.room.space.username)}>{SMFormatHelper.spaceName(reservation.room.space)}</a></li>
            );
          }
          else {
            metaRows.push(
              <li key="2">スペース：<a href={Routes.space_room_path(reservation.room.space.username, reservation.room.uid)}>{SMFormatHelper.roomName(reservation.room)}</a></li>
            );
          }
        }
        if (reservation.number_of_users) {
          metaRows.push(<li key="3">利用人数：{reservation.number_of_users}人</li>);
        }
      }

      if (reputation.from_type == "Owner") {
        const owner =  reputation.from;
        rows.push(
          <div key={reputation.id} className="mod-review__line clearfix">
            <a href={Routes.owner_path(owner.username)}><img src={owner.profile_image} alt={SMFormatHelper.ownerName(owner)} className="is-hover mod-review__guest-icon" /></a>
            <div className="mod-review__box-head">
              <h3 className="mod-review__guest-name link__subcolor"><a href={Routes.owner_path(owner.username)}><span itemProp="name">{SMFormatHelper.ownerName(owner)}</span></a></h3>
              <ul className="mod-review__list">
                {metaRows}
              </ul>
            </div>
            <div className="mod-review__box-text">
              <p>{reputation.description}</p>
            </div>
          </div>
        );
      }
      else if (reputation.from_type == "User") {
        rows.push(
          <div key={reputation.id} className="mod-review__line clearfix">
            {SMAppHelper.userIsDeleted(reputation.from) ?
              <img src={SMFormatHelper.defaultIcon()} alt={reputation.from.name} className="is-hover mod-review__guest-icon" /> :
              <a href={Routes.user_path(reputation.from.username)}><img src={reputation.from.profile_image} alt={reputation.from.name} className="is-hover mod-review__guest-icon" /></a>}
            <div className="mod-review__box-head">
              <h3 className="mod-review__guest-name link__subcolor">
                {SMAppHelper.userIsDeleted(reputation.from) ? <span>{reputation.from.name}</span> : <a href={Routes.user_path(reputation.from.username)}><span>{reputation.from.name}</span></a>}
              </h3>
              <ul className="mod-review__list">
                {metaRows}
              </ul>
            </div>
            <div className="mod-review__box-text">
              <p>{reputation.description}</p>
            </div>
          </div>
        );
      }
    });

    let classNames = ['mod-review__box'];
    if (reputated != 'Room') {
      classNames.push('mod-review__box-space');
    }
    return(
      <div className={classNames.join(' ')}>
        {rows}
      </div>
    );
  }

}
export default SMReputationListView;



// WEBPACK FOOTER //
// ./app/javascript/components/reputations/SMReputationListView.jsx